import { commentLikesApi as api } from './commentLikesApi';
export const addTagTypes = ['CommentLikes'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getCommentLikes: build.query<
        GetCommentLikesApiResponse,
        GetCommentLikesApiArg
      >({
        query: queryArg => ({
          url: `/commentLikes`,
          params: { commentId: queryArg.commentId }
        }),
        providesTags: ['CommentLikes']
      }),
      addCommentLikes: build.mutation<
        AddCommentLikesApiResponse,
        AddCommentLikesApiArg
      >({
        query: queryArg => ({
          url: `/commentLikes`,
          method: 'POST',
          body: queryArg.createCommentLikes
        }),
        invalidatesTags: ['CommentLikes']
      }),
      deleteCommentLikes: build.mutation<
        DeleteCommentLikesApiResponse,
        DeleteCommentLikesApiArg
      >({
        query: queryArg => ({
          url: `/commentLikes/${queryArg.id}`,
          method: 'DELETE',
          params: { commentId: queryArg.commentId }
        }),
        invalidatesTags: ['CommentLikes']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetCommentLikesApiResponse = /** status 200 CommentLikes found. */ {
  ok?: boolean;
  data?: CommentLikesCount;
  message?: string;
};
export type GetCommentLikesApiArg = {
  /** commentId */
  commentId?: string;
};
export type AddCommentLikesApiResponse =
  /** status 201 CommentLikes has been created successfully. */ {
    ok?: boolean;
    data?: CommentLikes;
    message?: string;
  };
export type AddCommentLikesApiArg = {
  /** CommentLikes that needs to be added to the application */
  createCommentLikes: CreateCommentLikes;
};
export type DeleteCommentLikesApiResponse =
  /** status 200 The CommentLikes's details has been deleted successfully */ {
    ok?: boolean;
    data?: string | null;
    message?: string;
  };
export type DeleteCommentLikesApiArg = {
  id: string;
  /** userId of the CommentLikes to delete */
  userId: string;
  /** commentId of the CommentLikes to delete */
  commentId: string;
};
export type CommentLikesCount = {
  count?: number;
};
export type CommentLikes = {
  count?: number;
  rows?: {
    id: string;
    commentId: string;
    userId: string;
    createdAt: string;
    updatedAt: string;
  }[];
};
export type CreateCommentLikes = {
  commentId: string;
  userId: string;
};
export const {
  useGetCommentLikesQuery,
  useAddCommentLikesMutation,
  useDeleteCommentLikesMutation
} = injectedRtkApi;
